export default __webpack_public_path__ + "static/media/sfml.88282224.jfif";